import { b2x } from '@b2x/react/src';

import { Page } from './Page';

export interface ServicePageProps {}

export const ServicePage = (props: ServicePageProps) => {
  return (
    <Page className="service-page">
      <b2x.ServicePage {...props} />
    </Page>
  );
};
